<template>
    <div>
        <div class="errorMessages" v-if="CONTACTS_NOT_FOUND">
            Je nám líto, ale nenalezli jsme žádné kontakty.
        </div>
        <div class="infoMessages" v-if="CONTACTS_PROCESSING">
            Načítám kontakty...
        </div>
        <div v-if="CONTACTS.length">
            <contact-contact-item :contact="contact" v-bind:key="contact.id" v-for="contact in CONTACTS"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {CONTACTS, CONTACTS_ERRORS, CONTACTS_PROCESSING, CONTACTS_NOT_FOUND} from './getter';
    import {NAMESPACE} from './store';
    import ContactContactItem from "./ContactItem";

    export default {
        name: 'ContactContactList',
        components: {
            ContactContactItem
        },
        computed: {
            ...mapGetters(NAMESPACE, [CONTACTS, CONTACTS_ERRORS, CONTACTS_PROCESSING, CONTACTS_NOT_FOUND]),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactList.vue